/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormatSelectItemPipe} from './format-select-item.pipe';
import {AddEmptySelectItemOptionPipe} from './add-empty-select-item-option.pipe';
import {ObjectToSelectItemListPipe} from './object-to-select-item-list.pipe';
import {FormatSelectItemsEnumAsyncPipe} from "./format-select-items-enum-async.pipe";
import {MapObjectToSelectItemPipe} from "./mapp-object-to-select-item.pipe";
import {AddEmptySelectItemOptionAsyncPipe} from './add-empty-select-item-option-async.pipe';
import {TranslateColumnsAsyncPipe} from './translate-columns-async.pipe';
import {BooleanSelectItemsProviderService} from "./boolean-select-items-provider.service";
import {FormatSelectItemEnumPipe} from "./format-select-item-enum.pipe";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
      FormatSelectItemEnumPipe,
      FormatSelectItemPipe,
      AddEmptySelectItemOptionPipe,
      ObjectToSelectItemListPipe,
      FormatSelectItemsEnumAsyncPipe,
      MapObjectToSelectItemPipe,
      AddEmptySelectItemOptionAsyncPipe,
      TranslateColumnsAsyncPipe
  ],
  exports: [
      FormatSelectItemEnumPipe,
      FormatSelectItemPipe,
      AddEmptySelectItemOptionPipe,
      ObjectToSelectItemListPipe,
      FormatSelectItemsEnumAsyncPipe,
      MapObjectToSelectItemPipe,
      AddEmptySelectItemOptionAsyncPipe,
      TranslateColumnsAsyncPipe
  ]
})
export class PrimengUtilsModule {
// Cand se vor adauga service-uri in modulul asta, vor trebui scrise metode de forRoot si forChild, ca sa avem aceeasi instanta de service in toate
    // modulele
    static forRoot(): ModuleWithProviders<PrimengUtilsModule> {
        return {
            ngModule: PrimengUtilsModule,
            providers: [
                BooleanSelectItemsProviderService
            ]
        };
    }
}
